import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import Box from 'ui-box';
import { Logo } from './components/Logo';
import { defaultFills, Heading, majorScale } from './npaper';
import { useStores } from './stores';

export const useMaintenanceCheck = (redirectOnSuccess?: boolean) => {
  const { authStore } = useStores();
  const history = useHistory();

  const PING_TIMEOUT = 60000; // Retry ping after 60 seconds

  useEffect(() => {
    const ping = () => {
      authStore
        .health()
        .then(() => {
          if (redirectOnSuccess) {
            history.replace('/');
          } else {
            setTimeout(() => {
              ping();
            }, PING_TIMEOUT);
          }
        })
        .catch((error) => {
          const unavailable =
            (error.request && !error.response) ||
            (error.response && error.response.status === 503);
          if (redirectOnSuccess && unavailable) {
            setTimeout(() => {
              ping();
            }, PING_TIMEOUT);
          } else if (unavailable) {
            window.location.assign('/maintenance');
          } else {
            history.push('/');
          }
        });
    };

    ping();
  }, [authStore, history, redirectOnSuccess]);
};

export const Maintenance = () => {
  useMaintenanceCheck(true);
  useEffect(() => {
    document.title = 'Offline for maintenance | Sails';
    return () => {
      document.title = 'Sails';
    };
  }, []);

  return (
    <Box
      height="100%"
      display="flex"
      alignItems="center"
      backgroundColor={defaultFills.normal[100]}
    >
      <Box
        maxWidth="440px"
        marginX="auto"
        textAlign="center"
        paddingBottom={majorScale(3)}
        paddingTop={majorScale(2)}
      >
        <Logo
          className="mx-auto"
          marginBottom={majorScale(2)}
          height={64}
          width={64}
        />
        <Heading size={600} marginBottom={majorScale(1)}>
          Offline for maintenance
        </Heading>
        <p>
          Sails is undergoing maintenance right now.
          <br />
          Please check back later.
        </p>
      </Box>
    </Box>
  );
};
